module.exports = __webpack_public_path__ + "static/media/lockIcon.d6f199a7.svg";